// extracted by mini-css-extract-plugin
module.exports = {"title":"TravelHighlightsList_title__kLiq5","list":"TravelHighlightsList_list__Bbr76"};